import { z } from "zod";
import { defineQuery } from "supabase/database/server.ts";
import { AccessReport } from "./types.ts";
import { api } from "supabase/database/api.ts";


export const getUserData = defineQuery(
  "getAuthUserData",
  {
  input: z.object({ reg_num: z.string() }),
  handler: async ({ db }, { reg_num }) => {
    const { data, error } = await db
      .from("access_report")
      .select("*")
      .eq("registration_number", reg_num);
    if (error) throw error;
    return data as AccessReport[];
  },
});

export const getUserInfo = defineQuery(
  "getUserInfo",
  {
  input: z.object({ email: z.email() }),
  handler: async ({ db }, { email }) => {
    const { data, error } = await db
      .from("access_report")
      .select("*")
      .eq("email", email);
    if (error) throw error;
    return data as AccessReport[];
  },
});

export const Login = defineQuery(
  "login",
  {
    input: z.object({
        scj_id: z.string(),
        password: z.string()
    }),
    handler: async ({ db }, { scj_id, password }) => {
        const user = await getUserData({ reg_num: scj_id });

        if (user.length > 0 && user[0].Access !== false){
            const email = user[0].email;
            const res = await db
                .auth
                .signInWithPassword({
                    email,
                    password
                });

            return [{
                result: !!res.data.user ? "Success" : "Login",
                message: !!res.data.user ?
                    "Successfully Logged in. Redirecting to Home page." :
                    res.error.message === "Invalid login credentials" ? "Incorrect Password" : res.error.message
            }]
        } else {
            return [{
                result: user.length === 0 ? "Login Failure" : "Technical Error",
                message: user.length === 0 ?
                    "User doesn't exist." :
                    `The Registration Number '${scj_id}' is Invalid.\n\nIf you believe this is an error, please inform your structure.`
            }]
        }
    }
})

export const GetPendingBasicInfoUpdate = defineQuery(
  "getPendingBasicInfoUpdate",
  {
    input: z.object({ email: z.email() }),
    handler: async ({ db }, { email }) => {
        const { data, error } = await db
            .from("basic_info_updates")
            .select("*")
            .eq("user_email", email)
            .eq("status", "pending")
            .order("created_at", { ascending: false })
            .limit(1);
        if (error) throw error;
        return data;
    },
});

export const Register = defineQuery(
  "register",
  {
    input: z.object({
        email: z.email(),
        scj_id: z.string(),
        password: z.string()
    }),
    handler: async ({ db }, { email, scj_id, password }) => {
        const user = await getUserData({ reg_num: scj_id });
        if (user.length === 0 || !!user[0].email){
            return [{
                result: "Failure",
                message: user.length === 0 ?
                    "User Doesn't Exist. Contact Structure to Register." :
                    "User Already Registered. Please Login."
            }]
        }
        
        const { data, error } = await db
            .auth
            .signUp({
                email: email,
                password: password
            })
        
        if (error) throw error;
        if (data.user !== null){
            await api.authMutations.UpdateEmail({ email, scj_id })
            window.location.href = "/verify-email";
            return [{
                result: "Success",
                message: "Successfully Registered.",
            }];
        } else {
            return [{
                result: "Failure",
                message: "Incorrect ID. Please Check Your ID Number",
            }];
        }
    }
})